function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg188VirginIslands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M284.986,204.563c0-16.008-12.977-28.986-28.986-28.986s-28.986,12.978-28.986,28.986h-63.768   c0,15.761,13.729,28.538,29.49,28.538h-0.949c0,15.762,12.777,28.541,28.54,28.541c0,13.955,10.023,25.551,23.26,28.031   l-0.075,0.167h24.977l-0.073-0.167c13.237-2.48,23.259-14.076,23.259-28.031c15.763,0,28.54-12.778,28.54-28.541h-0.951   c15.761,0,29.49-12.778,29.49-28.538L284.986,204.563L284.986,204.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M243.258,286.883l-17.972,40.575c9.483,3.856,19.847,5.997,30.714,5.997   c10.867,0,21.232-2.142,30.713-5.997l-17.971-40.575H243.258z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M218.899,218.817v49.928c0,28.399,37.101,37.101,37.101,37.101s37.101-8.702,37.101-37.101v-49.928  L218.899,218.817L218.899,218.817z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M126.719,257.201l20.066,56.123l19.857-56.123h15.154l-28.95,74.203h-12.123l-29.158-74.203   L126.719,257.201L126.719,257.201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M359.884,331.404v-74.203h14.423v74.203H359.884z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M233.739,234.94v60.503c5.101,3.753,10.588,6.337,14.84,7.989V234.94L233.739,234.94L233.739,234.94   z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M278.261,234.94v60.503c-5.101,3.753-10.588,6.337-14.84,7.989V234.94L278.261,234.94   L278.261,234.94z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 218.902,
    y: 218.813,
    style: {
      fill: "#0052B4"
    },
    width: 74.207,
    height: 23.541
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg188VirginIslands);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };